import React from "react";
import { Control, Controller, DeepMap, FieldError } from "react-hook-form";
import { Company } from "../../../core/api/models";
import ErrorMessage from "../../../components/text/ErrorMessage";
import { DropdownList } from "react-widgets";

interface CreateCompanySocialMediaFormProps {
    control: Control<Company>;
    errors: DeepMap<Company, FieldError>;
    validateProtocol: (value?: string | undefined) => true | "Please enter a URL with http:// or https://" | "Please enter a valid URL";
}

export function CreateCompanySocialMediaForm({ control,
    errors,
    validateProtocol }: CreateCompanySocialMediaFormProps) {
    return (
        <>
            <div className="col-12 py-3 border-bottom mb-3 py-1 font-base font-weight-semibold">
                Social Media
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Fax:
                </label>
                <Controller
                    control={control}
                    name="fax"
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Fax"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="fax"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Toll Free Number:
                </label>
                <Controller
                    control={control}
                    name="tollFree"
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="form-control rounded-sm font-weight-semibold"
                            placeholder="Toll Free Number"
                            name={name}
                            value={value}
                            onChange={onChange}
                            id="tollFree"
                        />
                    )}
                />
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    LinkedIn Page:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: 'Please enter the LinkedIn URL',
                        validate: (value) => {
                            return validateProtocol(value);
                        },
                    }}
                    name={"linkedin"}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder={'LinkedIn Page'}
                            name={name}
                            value={value}
                            onChange={onChange}
                        // onKeyDown={onFieldUpdate}
                        // id={props.property}
                        />
                    )}
                />
                {errors.linkedin && <ErrorMessage>{errors.linkedin.message}</ErrorMessage>}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Facebook Page:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: 'Please enter the Facebook URL',
                        validate: (value) => {
                            return validateProtocol(value);
                        },
                    }}
                    name={"facebook"}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder={'Facebook Page'}
                            name={name}
                            value={value}
                            onChange={onChange}
                        // onKeyDown={onFieldUpdate}
                        // id={props.property}
                        />
                    )}
                />
                {errors.facebook && <ErrorMessage>{errors.facebook.message}</ErrorMessage>}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Google+:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: 'Please enter the Google+ URL',
                        validate: (value) => {
                            return validateProtocol(value);
                        },
                    }}
                    name={"googlePlus"}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder={'google'}
                            name={name}
                            value={value}
                            onChange={onChange}
                        // onKeyDown={onFieldUpdate}
                        // id={props.property}
                        />
                    )}
                />
                {errors.googlePlus && <ErrorMessage>{errors.googlePlus.message}</ErrorMessage>}
            </div>
            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Twitter Page:
                </label>
                <Controller
                    control={control}
                    rules={{
                        // required: 'Please enter the Twitter URL',
                        validate: (value) => {
                            return validateProtocol(value);
                        },
                    }}
                    name={"twitter"}
                    render={({ onChange, value, name }) => (
                        <input
                            type="text"
                            className="font-sm font-weight-semibold form-control"
                            placeholder={'Company Name'}
                            name={name}
                            value={value}
                            onChange={onChange}
                        // onKeyDown={onFieldUpdate}
                        // id={props.property}
                        />
                    )}
                />
                {errors.twitter && <ErrorMessage>{errors.twitter.message}</ErrorMessage>}
            </div>

            <div className="col-3 mb-2 pb-1">
                <label className="font-sm font-weight-semibold mb-1" htmlFor="">
                    Mail restrictions:
                </label>
                <Controller
                    control={control}
                    // rules={{
                    //   required: true,
                    //   validate: (value) => {
                    //     return !!value.trim();
                    //   },
                    // }}
                    name={"mailRestriction"}
                    render={({ onChange, value, name }) => (
                        <DropdownList
                            value={value}
                            data={[
                                { name: "Yes", value: "yes" },
                                { name: "No", value: "no" },
                            ]}
                            textField={"name"}
                            valueField={"value"}
                            placeholder={"Select"}
                            onChange={(val) => {
                                onChange(val);
                            }}
                        />
                    )}
                />
                {errors.mailRestriction && <ErrorMessage>{errors.mailRestriction.message}</ErrorMessage>}
            </div>
        </>
    );
}
